export const translations = {
    fr: {
        brand: {
            name: "GAB'S SERVICES",
            sub: "SARL MALI",
            tagline: "Agence Immobilière",
        },
        topbar: {
            welcome: "Bienvenue chez GAB'S SERVICES SARL MALI",
        },
        nav: {
            home: "Accueil",
            services: "Nos Services",
            properties: "Biens Disponibles",
            about: "À Propos",
            contact: "Contact",
            quote: "Demander un devis",
            request: "Demande / Devis",
            couture: "Suivi Couture",
            admin: "Admin",
        },
        hero: {
            kicker: "Agence Immobilière au Mali",
            title_a: "Votre projet,",
            title_b: "notre priorité",
            description:
                "Achat, vente, courtage, gestion locative et plans 3D. Nous vous accompagnons à chaque étape, avec professionnalisme et transparence.",
            cta_primary: "Voir nos biens",
            cta_secondary: "Nous contacter",
        },
        services: {
            title: "Nos Services",
            subtitle:
                "Une expertise complète pour donner vie à vos projets immobiliers au Mali.",
            items: {
                terrain: {
                    title: "Vente de terrains",
                    text: "Nous vous proposons des terrains sécurisés et bien situés.",
                },
                courtage: {
                    title: "Courtage immobilier",
                    text: "Nous vous accompagnons dans l'achat et la vente de vos biens.",
                },
                gestion: {
                    title: "Gestion locative",
                    text: "Nous prenons en charge la gestion complète de vos biens immobiliers.",
                },
                garantie: {
                    title: "Garantie de paiement des loyers",
                    text: "Nous vous garantissons le paiement sécurisé de vos loyers.",
                },
                plans: {
                    title: "Plans 3D",
                    text: "Nous réalisons vos plans en 3D pour mieux concrétiser vos projets.",
                },
                accompagnement: {
                    title: "Accompagnement personnalisé",
                    text: "Un suivi rigoureux à chaque étape de votre projet immobilier.",
                },
            },
        },
        featured: {
            title: "Biens en vedette",
            subtitle: "Une sélection rigoureuse de biens disponibles à Bamako.",
            see_details: "Voir les détails",
            for_sale: "À vendre",
            for_rent: "À louer",
            per_month: "/ mois",
            see_all: "Voir tous les biens",
        },
        why: {
            title: "Pourquoi nous choisir ?",
            satisfied: "Clients satisfaits",
            items: {
                expertise: {
                    title: "Expertise locale",
                    text: "Une parfaite connaissance du marché immobilier au Mali.",
                },
                transparency: {
                    title: "Transparence",
                    text: "Des transactions claires et sécurisées.",
                },
                support: {
                    title: "Accompagnement personnalisé",
                    text: "Nous vous suivons à chaque étape de votre projet.",
                },
                satisfaction: {
                    title: "Satisfaction client",
                    text: "Votre satisfaction est notre priorité absolue.",
                },
            },
        },
        hours: {
            title: "Heures d'ouverture",
            mon_thu: "Lundi – Jeudi",
            fri: "Vendredi",
            sat: "Samedi",
            sun: "Dimanche",
            closed: "Fermé",
            ribbon: "Une équipe disponible pour vous servir",
        },
        public_cockpit: {
            kicker: "Notre engagement en chiffres",
            title: "Une performance mesurée, publiée en toute transparence.",
            subtitle: "Nous publions ici, en temps réel, nos indicateurs de service client — parce que la confiance se prouve.",
            properties: "Biens en catalogue",
            inquiries: "Demandes reçues",
            response_rate: "Taux de réponse",
            processing_rate: "Taux de traitement",
            avg_response: "Temps moyen de réponse",
            performance: "Performance globale",
            live: "En direct",
            note: "Ces chiffres sont recalculés à chaque instant à partir de nos données internes.",
        },
        cta_band: {
            text: "Vous avez un projet immobilier ? Parlons-en !",
            button: "Contactez-nous",
        },
        properties: {
            title: "Biens Disponibles",
            subtitle:
                "Découvrez l'ensemble de notre portefeuille immobilier au Mali.",
            filters: {
                all: "Tous",
                transaction: "Transaction",
                type: "Type",
                city: "Ville",
                sale: "Vente",
                rent: "Location",
                terrain: "Terrain",
                villa: "Villa",
                appartement: "Appartement",
                maison: "Maison",
                reset: "Réinitialiser",
            },
            empty: "Aucun bien ne correspond à votre recherche.",
            bedrooms: "Chambres",
            bathrooms: "Salles de bain",
            surface: "Surface",
            contact_whatsapp: "Contacter via WhatsApp",
            back: "Retour aux biens",
        },
        about: {
            title: "À propos de GAB'S SERVICES",
            kicker: "L'immobilier en toute confiance",
            text_1:
                "GAB'S SERVICES SARL MALI est une agence immobilière basée à Bamako. Nous mettons notre expertise locale au service de particuliers, investisseurs et entreprises pour réussir leurs projets immobiliers au Mali.",
            text_2:
                "De la vente de terrains à la gestion locative, en passant par les plans 3D et le courtage, nous offrons un service complet, transparent et personnalisé.",
            values_title: "Notre engagement",
            values: [
                "Écoute et conseil personnalisé",
                "Transparence et honnêteté",
                "Réactivité et disponibilité",
                "Solutions adaptées à vos besoins",
                "Accompagnement de A à Z",
            ],
        },
        contact: {
            title: "Contactez-nous",
            subtitle:
                "Notre équipe est à votre écoute pour répondre à toutes vos questions.",
            phones: "Téléphones",
            email: "Email",
            website: "Site web",
            address: "Adresse",
            address_value: "Bamako, Mali",
            form: {
                name: "Nom complet",
                email: "Email",
                phone: "Téléphone",
                subject: "Sujet",
                message: "Votre message",
                send: "Envoyer le message",
                whatsapp: "Discuter sur WhatsApp",
                success: "Message envoyé avec succès !",
                error: "Échec de l'envoi. Veuillez réessayer.",
            },
        },
        footer: {
            tagline: "Votre partenaire immobilier de confiance au Mali.",
            quick_links: "Liens rapides",
            our_services: "Nos services",
            contact: "Contact",
            follow: "Suivez-nous",
            rights: "Tous droits réservés",
        },
        inquiry: {
            hero_kicker: "Demande d'information ou de devis",
            hero_title_a: "Un projet ?",
            hero_title_b: "Écrivons-le ensemble.",
            hero_desc: "Renseignez ce formulaire — un conseiller GAB'S SERVICES vous répond sous 24h ouvrées avec une proposition personnalisée.",
            chapter_1: "Chapitre 01 · Vos coordonnées",
            chapter_2: "Chapitre 02 · Votre besoin",
            chapter_3: "Chapitre 03 · Votre projet immobilier",
            chapter_4: "Chapitre 04 · Message & envoi",
            name: "Nom & prénom",
            email: "Adresse e-mail",
            phone: "Téléphone",
            whatsapp: "WhatsApp (si différent)",
            type: "Nature de la demande",
            type_info: "Information",
            type_quote: "Devis / Estimation",
            property_ref: "Bien concerné (facultatif)",
            property_ref_placeholder: "Ex : Villa Duplex 5 pièces – Hippodrome",
            property_type: "Type de bien recherché",
            transaction: "Objet",
            transaction_sale: "Achat",
            transaction_rent: "Location",
            city: "Ville",
            budget: "Budget (FCFA)",
            timeline: "Délai souhaité",
            timeline_immediate: "Immédiat",
            timeline_1_3: "1 à 3 mois",
            timeline_3_6: "3 à 6 mois",
            timeline_6plus: "Plus de 6 mois",
            message: "Détails du projet",
            message_placeholder: "Décrivez votre projet, vos attentes, contraintes ou questions…",
            submit: "Envoyer la demande",
            submitting: "Envoi…",
            success_title: "Demande envoyée",
            success_desc: "Merci — notre équipe vous recontacte sous 24h ouvrées.",
            error: "Une erreur est survenue, veuillez réessayer.",
            promise_1: "Confidentialité stricte",
            promise_2: "Réponse sous 24h ouvrées",
            promise_3: "Suivi personnalisé",
        },
        cockpit: {
            title: "Cockpit de performance",
            subtitle: "Suivi en temps réel de vos demandes clients.",
            total: "Demandes totales",
            new: "Nouveau",
            in_progress: "En cours",
            responded: "Répondu",
            closed: "Clôturé",
            processing_rate: "Taux de traitement",
            response_rate: "Taux de réponse",
            avg_response: "Temps moyen de réponse",
            speed_score: "Score de rapidité",
            performance: "Performance globale",
            hours: "h",
            volume_14d: "Volume — 14 derniers jours",
            by_type: "Par nature",
            info: "Information",
            quote: "Devis",
            hub_title: "Espaces d'administration",
            hub_subtitle: "Accédez à toutes les zones que vous pouvez gérer.",
            hub_inquiries: "Demandes clients",
            hub_inquiries_sub: "Consulter, traiter et répondre aux demandes",
            hub_properties: "Biens immobiliers",
            hub_properties_sub: "Ajouter, modifier ou supprimer un bien",
            hub_new_property: "Nouveau bien",
            hub_new_property_sub: "Publier une nouvelle annonce",
            hub_messages: "Messages contact",
            hub_messages_sub: "Voir les messages du formulaire de contact",
            hub_settings: "Paramètres du site",
            hub_settings_sub: "Éditer tous les contenus visibles du site",
            recent_inquiries: "Dernières demandes",
            recent_messages: "Derniers messages",
            recent_empty: "Aucune activité pour le moment.",
            open: "Ouvrir",
        },
        inquiries: {
            title: "Demandes clients",
            filters: {
                all: "Toutes",
                status: "Statut",
                type: "Nature",
            },
            columns: {
                date: "Date",
                name: "Client",
                type: "Nature",
                subject: "Objet",
                status: "Statut",
                actions: "Actions",
            },
            details: "Détails",
            client_info: "Informations client",
            project_info: "Détails du projet",
            update_status: "Statut",
            response: "Réponse à envoyer / notes internes",
            response_placeholder: "Notes internes / message adressé au client…",
            save: "Enregistrer",
            close_drawer: "Fermer",
            deleted: "Demande supprimée",
            saved: "Enregistré",
            empty: "Aucune demande.",
        },
        booking: {
            nav: "Réservations",
            hero_kicker: "Réservation en ligne",
            hero_title: "Réservez en quelques clics.",
            hero_desc: "Location courte durée ou rendez-vous conseil : choisissez, envoyez, nous confirmons.",
            tab_rental: "Location courte durée",
            tab_meeting: "Rendez-vous conseil",
            rental_property: "Bien à réserver",
            rental_pick_property: "— Sélectionner un bien —",
            rental_check_in: "Date d'arrivée",
            rental_check_out: "Date de départ",
            rental_guests: "Nombre de personnes",
            meeting_pick_slot: "Choisir un créneau",
            meeting_no_slots: "Aucun créneau disponible pour le moment.",
            name: "Nom & prénom",
            email: "Email",
            phone: "Téléphone",
            whatsapp: "WhatsApp (si différent)",
            message: "Message (facultatif)",
            submit: "Envoyer la réservation",
            submitting: "Envoi…",
            success_title: "Réservation envoyée",
            success_desc: "Merci — nous confirmons votre réservation sous 24h.",
            track_link: "Suivre votre réservation",
            error: "Une erreur est survenue",
            date_unavailable: "Dates non disponibles pour ce bien.",
            slot_taken: "Ce créneau vient d'être réservé.",
        },
        track: {
            title: "Suivi de réservation",
            not_found: "Réservation introuvable.",
            copy_link: "Copier le lien",
            link_copied: "Lien copié !",
            status_pending: "En attente de confirmation",
            status_confirmed: "Confirmée",
            status_completed: "Terminée",
            status_cancelled: "Annulée",
        },
        bookings_admin: {
            title: "Réservations",
            slots_title: "Créneaux de rendez-vous",
            new_slot: "Nouveau créneau",
            slot_date: "Date",
            slot_start: "Début",
            slot_end: "Fin",
            slot_label: "Libellé (facultatif)",
            add: "Ajouter",
            delete: "Supprimer",
            columns: {
                date: "Date",
                client: "Client",
                type: "Type",
                details: "Détails",
                status: "Statut",
                actions: "Actions",
            },
            rental: "Location",
            meeting: "Rendez-vous",
            admin_note: "Note interne",
            admin_note_placeholder: "Note interne (facultative)…",
            wa_click: "WhatsApp au client",
            confirm: "Confirmer",
            complete: "Terminée",
            cancel: "Annuler",
            reopen: "Rouvrir",
            deleted: "Supprimée",
            saved: "Enregistrée",
            empty: "Aucune réservation.",
            hub: "Réservations",
            hub_sub: "Confirmer, terminer ou annuler",
        },

        admin: {
            login_title: "Connexion Administrateur",
            email: "Email",
            password: "Mot de passe",
            login: "Se connecter",
            logging_in: "Connexion...",
            dashboard: "Tableau de bord",
            properties: "Biens immobiliers",
            messages: "Messages",
            new_property: "Nouveau bien",
            edit_property: "Modifier le bien",
            logout: "Déconnexion",
            confirm_delete: "Supprimer ce bien ?",
            saved: "Enregistré avec succès",
            deleted: "Supprimé",
            actions: "Actions",
            edit: "Modifier",
            delete: "Supprimer",
            featured: "Vedette",
            available: "Disponible",
            yes: "Oui",
            no: "Non",
            save: "Enregistrer",
            cancel: "Annuler",
            upload_photo: "Envoyer des photos",
            image_url_label: "Ou ajouter par URL",
            upload_hint: "Vos photos sont stockées en ligne de façon durable. Vous pouvez aussi coller une URL ci-dessous.",
            loading: "Chargement…",
            saving: "Enregistrement…",
        },
        settings: {
            title: "Paramètres du site",
            subtitle: "Modifiez tous les contenus visibles par vos visiteurs.",
            tabs: {
                identity: "Identité",
                contact: "Coordonnées",
                hours: "Horaires",
                socials: "Réseaux sociaux",
                brand: "Chiffre marque",
                hero: "Bloc Hero",
                services: "Services (6)",
                about: "À propos",
                cta: "Bandeau CTA",
            },
            phones: "Numéros de téléphone (3)",
            phones_hint: "Format d'affichage libre. Le numéro WhatsApp doit être en format international sans espaces (ex : 22375334658).",
            phone_display: "Affichage",
            phone_wa: "N° WhatsApp",
            emails: "E-mails (2)",
            website: "Site web",
            address: "Adresse",
            mon_thu: "Lundi – Jeudi",
            fri: "Vendredi",
            sat: "Samedi",
            sun: "Dimanche",
            facebook_url: "URL Facebook",
            instagram_url: "URL Instagram",
            whatsapp_default: "N° WhatsApp par défaut (bouton flottant)",
            clients_satisfied: "Nombre de clients satisfaits (affiché en +XXX)",
            hero_image: "Image du hero (URL)",
            hero_kicker: "Kicker",
            hero_title_a: "Titre (partie 1)",
            hero_title_b: "Titre (partie 2, en italique or)",
            hero_desc: "Description",
            service_key: "Clé (identifiant technique)",
            service_icon: "Icône (LandPlot, Handshake, Building2, ShieldCheck, Box, Users)",
            service_title: "Titre",
            service_text: "Description",
            about_image: "Image (URL)",
            about_kicker: "Kicker",
            about_title: "Titre",
            about_text_1: "Paragraphe 1",
            about_text_2: "Paragraphe 2",
            about_values_title: "Titre des engagements",
            about_values: "Engagements (un par ligne)",
            cta_text: "Phrase d'accroche",
            cta_button: "Libellé du bouton",
            fr: "Français",
            en: "Anglais",
            identity_name: "Nom de l'entreprise",
            identity_sub: "Sous-titre / Mention",
            identity_logo: "Logo de l'entreprise",
            identity_logo_hint: "Envoyez votre logo (PNG transparent recommandé) ou collez une URL. Le logo remplacera l'icône par défaut partout sur le site.",
            identity_note: "Le nom et le logo apparaissent dans l'en-tête, le pied de page, l'espace couture et l'onglet du navigateur.",
            save_all: "Enregistrer les modifications",
            saved: "Modifications enregistrées avec succès",
            error: "Erreur lors de l'enregistrement",
        },
        couture: {
            space: "Espace Couture",
            login_title: "Espace Couturier",
            login_sub: "Gestion des commandes couture",
            login_wrong_role: "Ce compte n'a pas accès à l'espace couture",
            dashboard: "Tableau de bord",
            orders: "Commandes",
            new_order: "Nouvelle commande",
            categories: "Catégories",
            measurement_fields: "Champs de mesures",
            settings: "Paramètres",
            settings_saved: "Paramètres enregistrés",
            settings_hint: "Ces informations (nom, logo, coordonnées) apparaissent sur vos devis et factures couture.",
            kpi_orders: "Commandes",
            kpi_revenue: "Chiffre d'affaires",
            kpi_deposits: "Acomptes reçus",
            kpi_outstanding: "Reste à encaisser",
            kpi_profit: "Bénéfice",
            pipeline_title: "Étapes de production",
            filter_all: "Toutes",
            load_error: "Erreur de chargement",
            no_orders: "Aucune commande pour le moment",
            tracking_code: "Code de suivi",
            client: "Client",
            category: "Catégorie",
            subcategory: "Sous-catégorie",
            stage: "Étape",
            price: "Prix",
            balance: "Solde",
            deposit: "Acompte",
            status: "Statut",
            actions: "Actions",
            open: "Ouvrir",
            delete: "Supprimer",
            confirm_delete: "Supprimer cette commande ?",
            deleted: "Supprimé",
            created: "Commande créée",
            saved: "Enregistré",
            doc_created: "Document généré",
            stage_commande: "Commande",
            stage_mesures: "Mesures",
            stage_coupe: "Coupe",
            stage_couture: "Couture",
            stage_finitions: "Finitions",
            stage_pret: "Prêt",
            stage_livre: "Livré",
            status_en_cours: "En cours",
            status_pret: "Prêt",
            status_livre: "Livré",
            status_annule: "Annulé",
            section_client: "Informations client",
            section_model: "Modèle",
            section_measurements: "Mesures (cm)",
            section_payment: "Prix et paiement",
            client_name: "Nom du client",
            client_phone: "Téléphone",
            client_email: "Email",
            description: "Description",
            price_fcfa: "Prix de vente (FCFA)",
            price_eur: "Prix (EUR)",
            cost_fcfa: "Prix d'achat (FCFA)",
            cost: "Coût total",
            profit: "Bénéfice",
            cost: "Prix d'achat",
            deposit_fcfa: "Acompte versé (FCFA)",
            due_date: "Date de livraison prévue",
            create_order: "Créer la commande",
            make_devis: "Générer un devis",
            make_facture: "Générer une facture",
            documents: "Documents",
            no_documents: "Aucun document généré",
            print: "Imprimer",
            doc_devis: "Devis",
            doc_facture: "Facture",
            back_to_order: "Retour à la commande",
            from: "Émetteur",
            bill_to: "Facturé à",
            item: "Désignation",
            custom_order: "Commande sur mesure",
            devis_footer: "Devis valable 30 jours. Merci de votre confiance.",
            facture_footer: "Merci de votre confiance. GAB'S SERVICES SARL MALI.",
            track_title: "Suivi de commande couture",
            track_sub: "Entrez votre code de suivi pour connaître l'avancement de votre commande.",
            track_placeholder: "Ex : GSC-A1B2C3",
            track_button: "Suivre",
            add_category: "Ajouter",
            category_name_fr: "Nom (Français)",
            category_name_en: "Nom (Anglais)",
            cat_price: "Prix de vente (FCFA)",
            cost_lines: "Décomposition des coûts",
            cost_lines_hint: "Ajoutez les postes de coût (tissu, doublure, main-d'œuvre...). Le total se calcule automatiquement.",
            cost_label_ph: "Libellé (ex : Tissu)",
            add_cost_line: "Ajouter un poste",
            cat_price_hint: "Le prix de vente et la décomposition des coûts se pré-rempliront lors de la création d'une commande avec cette catégorie (modifiables ensuite).",
            parent_section: "Section parente (optionnel)",
            no_parent: "Aucune — c'est une section principale",
            category_created: "Catégorie créée",
            no_categories: "Aucune catégorie pour le moment",
            add_field: "Ajouter le champ",
            field_key: "Clé technique",
            field_label_fr: "Libellé (Français)",
            field_label_en: "Libellé (Anglais)",
            field_unit: "Unité",
            field_created: "Champ créé",
            no_fields: "Aucun champ de mesure",
        },
    },
    en: {
        brand: {
            name: "GAB'S SERVICES",
            sub: "SARL MALI",
            tagline: "Real Estate Agency",
        },
        topbar: {
            welcome: "Welcome to GAB'S SERVICES SARL MALI",
        },
        nav: {
            home: "Home",
            services: "Services",
            properties: "Properties",
            about: "About",
            contact: "Contact",
            quote: "Request a quote",
            request: "Inquiry / Quote",
            couture_track: "Tailoring tracking",
            admin: "Admin",
        },
        hero: {
            kicker: "Real Estate Agency in Mali",
            title_a: "Your project,",
            title_b: "our priority",
            description:
                "Purchase, sale, brokerage, rental management and 3D plans. We support you every step of the way with professionalism and transparency.",
            cta_primary: "View properties",
            cta_secondary: "Contact us",
        },
        services: {
            title: "Our Services",
            subtitle:
                "Comprehensive expertise to bring your real estate projects in Mali to life.",
            items: {
                terrain: {
                    title: "Land Sales",
                    text: "We offer secured and well-located land plots.",
                },
                courtage: {
                    title: "Real Estate Brokerage",
                    text: "We support you in buying and selling your properties.",
                },
                gestion: {
                    title: "Rental Management",
                    text: "We take care of the full management of your real estate assets.",
                },
                garantie: {
                    title: "Rent Payment Guarantee",
                    text: "We guarantee secured payment of your rents.",
                },
                plans: {
                    title: "3D Plans",
                    text: "We create 3D plans to bring your projects to life.",
                },
                accompagnement: {
                    title: "Personalised Support",
                    text: "Rigorous follow-up at every step of your project.",
                },
            },
        },
        featured: {
            title: "Featured Properties",
            subtitle: "A curated selection of properties available in Bamako.",
            see_details: "View details",
            for_sale: "For sale",
            for_rent: "For rent",
            per_month: "/ month",
            see_all: "View all properties",
        },
        why: {
            title: "Why choose us?",
            satisfied: "Happy clients",
            items: {
                expertise: {
                    title: "Local expertise",
                    text: "Deep knowledge of the Malian real estate market.",
                },
                transparency: {
                    title: "Transparency",
                    text: "Clear and secured transactions.",
                },
                support: {
                    title: "Personalised support",
                    text: "We support you every step of your project.",
                },
                satisfaction: {
                    title: "Client satisfaction",
                    text: "Your satisfaction is our top priority.",
                },
            },
        },
        hours: {
            title: "Opening hours",
            mon_thu: "Monday – Thursday",
            fri: "Friday",
            sat: "Saturday",
            sun: "Sunday",
            closed: "Closed",
            ribbon: "A team available to serve you",
        },
        public_cockpit: {
            kicker: "Our commitment in numbers",
            title: "Measured performance, published transparently.",
            subtitle: "We publish our client-service KPIs in real time — because trust is proven, not claimed.",
            properties: "Listings",
            inquiries: "Inquiries received",
            response_rate: "Response rate",
            processing_rate: "Processing rate",
            avg_response: "Avg. response time",
            performance: "Overall performance",
            live: "Live",
            note: "These figures are recomputed continuously from our internal data.",
        },
        cta_band: {
            text: "Have a real estate project? Let's talk!",
            button: "Contact us",
        },
        properties: {
            title: "Available Properties",
            subtitle: "Discover our full real estate portfolio in Mali.",
            filters: {
                all: "All",
                transaction: "Transaction",
                type: "Type",
                city: "City",
                sale: "Sale",
                rent: "Rent",
                terrain: "Land",
                villa: "Villa",
                appartement: "Apartment",
                maison: "House",
                reset: "Reset",
            },
            empty: "No property matches your search.",
            bedrooms: "Bedrooms",
            bathrooms: "Bathrooms",
            surface: "Surface",
            contact_whatsapp: "Contact via WhatsApp",
            back: "Back to properties",
        },
        about: {
            title: "About GAB'S SERVICES",
            kicker: "Real estate with confidence",
            text_1:
                "GAB'S SERVICES SARL MALI is a real estate agency based in Bamako. We put our local expertise at the service of individuals, investors and companies to succeed in their real estate projects in Mali.",
            text_2:
                "From land sales to rental management, including 3D plans and brokerage, we offer a complete, transparent and personalised service.",
            values_title: "Our commitment",
            values: [
                "Personalised advice and listening",
                "Transparency and honesty",
                "Responsiveness and availability",
                "Tailored solutions",
                "Full A-to-Z support",
            ],
        },
        contact: {
            title: "Contact us",
            subtitle: "Our team is here to answer all your questions.",
            phones: "Phones",
            email: "Email",
            website: "Website",
            address: "Address",
            address_value: "Bamako, Mali",
            form: {
                name: "Full name",
                email: "Email",
                phone: "Phone",
                subject: "Subject",
                message: "Your message",
                send: "Send message",
                whatsapp: "Chat on WhatsApp",
                success: "Message sent successfully!",
                error: "Sending failed. Please try again.",
            },
        },
        footer: {
            tagline: "Your trusted real estate partner in Mali.",
            quick_links: "Quick links",
            our_services: "Our services",
            contact: "Contact",
            follow: "Follow us",
            rights: "All rights reserved",
        },
        inquiry: {
            hero_kicker: "Inquiry / Quote request",
            hero_title_a: "A project?",
            hero_title_b: "Let's write it together.",
            hero_desc: "Fill in the form — a GAB'S SERVICES advisor replies within 24 business hours with a tailored proposal.",
            chapter_1: "Chapter 01 · Your details",
            chapter_2: "Chapter 02 · Your need",
            chapter_3: "Chapter 03 · Your real estate project",
            chapter_4: "Chapter 04 · Message & submit",
            name: "Full name",
            email: "Email address",
            phone: "Phone",
            whatsapp: "WhatsApp (if different)",
            type: "Nature of request",
            type_info: "Information",
            type_quote: "Quote / Estimate",
            property_ref: "Property of interest (optional)",
            property_ref_placeholder: "Ex: 5-Room Duplex Villa – Hippodrome",
            property_type: "Property type sought",
            transaction: "Intent",
            transaction_sale: "Purchase",
            transaction_rent: "Rental",
            city: "City",
            budget: "Budget (FCFA)",
            timeline: "Desired timeline",
            timeline_immediate: "Immediate",
            timeline_1_3: "1 to 3 months",
            timeline_3_6: "3 to 6 months",
            timeline_6plus: "Over 6 months",
            message: "Project details",
            message_placeholder: "Describe your project, expectations, constraints or questions…",
            submit: "Send request",
            submitting: "Sending…",
            success_title: "Request sent",
            success_desc: "Thank you — our team will reach out within 24 business hours.",
            error: "An error occurred, please try again.",
            promise_1: "Strict confidentiality",
            promise_2: "Reply within 24 business hours",
            promise_3: "Personalised follow-up",
        },
        cockpit: {
            title: "Performance cockpit",
            subtitle: "Real-time monitoring of your client requests.",
            total: "Total requests",
            new: "New",
            in_progress: "In progress",
            responded: "Responded",
            closed: "Closed",
            processing_rate: "Processing rate",
            response_rate: "Response rate",
            avg_response: "Average response time",
            speed_score: "Speed score",
            performance: "Overall performance",
            hours: "h",
            volume_14d: "Volume — last 14 days",
            by_type: "By nature",
            info: "Information",
            quote: "Quote",
            hub_title: "Admin areas",
            hub_subtitle: "Access every area you can manage.",
            hub_inquiries: "Client requests",
            hub_inquiries_sub: "Read, process and reply to requests",
            hub_properties: "Properties",
            hub_properties_sub: "Add, edit or remove a property",
            hub_new_property: "New property",
            hub_new_property_sub: "Publish a new listing",
            hub_messages: "Contact messages",
            hub_messages_sub: "View messages from the contact form",
            hub_settings: "Site settings",
            hub_settings_sub: "Edit all public site content",
            recent_inquiries: "Latest requests",
            recent_messages: "Latest messages",
            recent_empty: "No recent activity.",
            open: "Open",
        },
        inquiries: {
            title: "Client requests",
            filters: {
                all: "All",
                status: "Status",
                type: "Nature",
            },
            columns: {
                date: "Date",
                name: "Client",
                type: "Nature",
                subject: "Subject",
                status: "Status",
                actions: "Actions",
            },
            details: "Details",
            client_info: "Client information",
            project_info: "Project details",
            update_status: "Status",
            response: "Reply to send / internal notes",
            response_placeholder: "Internal notes / message to client…",
            save: "Save",
            close_drawer: "Close",
            deleted: "Request deleted",
            saved: "Saved",
            empty: "No requests.",
        },
        admin: {
            login_title: "Administrator Login",
            email: "Email",
            password: "Password",
            login: "Sign in",
            logging_in: "Signing in...",
            dashboard: "Dashboard",
            properties: "Properties",
            messages: "Messages",
            new_property: "New property",
            edit_property: "Edit property",
            logout: "Logout",
            confirm_delete: "Delete this property?",
            saved: "Saved successfully",
            deleted: "Deleted",
            actions: "Actions",
            edit: "Edit",
            delete: "Delete",
            featured: "Featured",
            available: "Available",
            yes: "Yes",
            no: "No",
            save: "Save",
            cancel: "Cancel",
            upload_photo: "Upload photos",
            image_url_label: "Or add by URL",
            upload_hint: "Your photos are stored online durably. You can also paste a URL below.",
            loading: "Loading…",
            saving: "Saving…",
        },
        settings: {
            title: "Site settings",
            subtitle: "Edit all content visible to your visitors.",
            tabs: {
                identity: "Identity",
                contact: "Contact",
                hours: "Hours",
                socials: "Socials",
                brand: "Brand number",
                hero: "Hero block",
                services: "Services (6)",
                about: "About",
                cta: "CTA banner",
            },
            phones: "Phone numbers (3)",
            phones_hint: "Display format is free. WhatsApp number must be international format without spaces (e.g. 22375334658).",
            phone_display: "Display",
            phone_wa: "WhatsApp #",
            emails: "Emails (2)",
            website: "Website",
            address: "Address",
            mon_thu: "Monday – Thursday",
            fri: "Friday",
            sat: "Saturday",
            sun: "Sunday",
            facebook_url: "Facebook URL",
            instagram_url: "Instagram URL",
            whatsapp_default: "Default WhatsApp # (floating button)",
            clients_satisfied: "Satisfied clients count (displayed as +XXX)",
            hero_image: "Hero image (URL)",
            hero_kicker: "Kicker",
            hero_title_a: "Title (part 1)",
            hero_title_b: "Title (part 2, italic gold)",
            hero_desc: "Description",
            service_key: "Key (technical id)",
            service_icon: "Icon (LandPlot, Handshake, Building2, ShieldCheck, Box, Users)",
            service_title: "Title",
            service_text: "Description",
            about_image: "Image (URL)",
            about_kicker: "Kicker",
            about_title: "Title",
            about_text_1: "Paragraph 1",
            about_text_2: "Paragraph 2",
            about_values_title: "Values title",
            about_values: "Values (one per line)",
            cta_text: "Tagline",
            cta_button: "Button label",
            fr: "French",
            en: "English",
            identity_name: "Company name",
            identity_sub: "Subtitle / Tagline",
            identity_logo: "Company logo",
            identity_logo_hint: "Upload your logo (transparent PNG recommended) or paste a URL. The logo replaces the default icon across the site.",
            identity_note: "The name and logo appear in the header, footer, tailoring space and browser tab.",
            save_all: "Save changes",
            saved: "Changes saved successfully",
            error: "Save failed",
        },
        booking: {
            nav: "Bookings",
            hero_kicker: "Online booking",
            hero_title: "Book in a few clicks.",
            hero_desc: "Short-term rental or advisory meeting: choose, submit, we confirm.",
            tab_rental: "Short-term rental",
            tab_meeting: "Advisory meeting",
            rental_property: "Property to book",
            rental_pick_property: "— Pick a property —",
            rental_check_in: "Check-in date",
            rental_check_out: "Check-out date",
            rental_guests: "Number of guests",
            meeting_pick_slot: "Pick a slot",
            meeting_no_slots: "No slots currently available.",
            name: "Full name",
            email: "Email",
            phone: "Phone",
            whatsapp: "WhatsApp (if different)",
            message: "Message (optional)",
            submit: "Send booking",
            submitting: "Sending…",
            success_title: "Booking sent",
            success_desc: "Thank you — we confirm your booking within 24h.",
            track_link: "Track your booking",
            error: "Something went wrong",
            date_unavailable: "Dates not available for this property.",
            slot_taken: "This slot was just booked.",
        },
        track: {
            title: "Booking tracking",
            not_found: "Booking not found.",
            copy_link: "Copy link",
            link_copied: "Link copied!",
            status_pending: "Pending confirmation",
            status_confirmed: "Confirmed",
            status_completed: "Completed",
            status_cancelled: "Cancelled",
        },
        bookings_admin: {
            title: "Bookings",
            slots_title: "Meeting slots",
            new_slot: "New slot",
            slot_date: "Date",
            slot_start: "Start",
            slot_end: "End",
            slot_label: "Label (optional)",
            add: "Add",
            delete: "Delete",
            columns: {
                date: "Date",
                client: "Client",
                type: "Type",
                details: "Details",
                status: "Status",
                actions: "Actions",
            },
            rental: "Rental",
            meeting: "Meeting",
            admin_note: "Internal note",
            admin_note_placeholder: "Internal note (optional)…",
            wa_click: "WhatsApp client",
            confirm: "Confirm",
            complete: "Completed",
            cancel: "Cancel",
            reopen: "Reopen",
            deleted: "Deleted",
            saved: "Saved",
            empty: "No bookings.",
            hub: "Bookings",
            hub_sub: "Confirm, complete or cancel",
        },
        couture: {
            space: "Tailoring Space",
            login_title: "Tailor Space",
            login_sub: "Tailoring order management",
            login_wrong_role: "This account has no access to the tailoring space",
            dashboard: "Dashboard",
            orders: "Orders",
            new_order: "New order",
            categories: "Categories",
            measurement_fields: "Measurement fields",
            settings: "Settings",
            settings_saved: "Settings saved",
            settings_hint: "This information (name, logo, contact) appears on your tailoring quotes and invoices.",
            kpi_orders: "Orders",
            kpi_revenue: "Revenue",
            kpi_deposits: "Deposits received",
            kpi_outstanding: "Outstanding",
            kpi_profit: "Profit",
            pipeline_title: "Production stages",
            filter_all: "All",
            load_error: "Loading error",
            no_orders: "No orders yet",
            tracking_code: "Tracking code",
            client: "Client",
            category: "Category",
            subcategory: "Subcategory",
            stage: "Stage",
            price: "Price",
            balance: "Balance",
            deposit: "Deposit",
            status: "Status",
            actions: "Actions",
            open: "Open",
            delete: "Delete",
            confirm_delete: "Delete this order?",
            deleted: "Deleted",
            created: "Order created",
            saved: "Saved",
            doc_created: "Document generated",
            stage_commande: "Order",
            stage_mesures: "Measurements",
            stage_coupe: "Cutting",
            stage_couture: "Sewing",
            stage_finitions: "Finishing",
            stage_pret: "Ready",
            stage_livre: "Delivered",
            status_en_cours: "In progress",
            status_pret: "Ready",
            status_livre: "Delivered",
            status_annule: "Cancelled",
            section_client: "Client information",
            section_model: "Model",
            section_measurements: "Measurements (cm)",
            section_payment: "Price and payment",
            client_name: "Client name",
            client_phone: "Phone",
            client_email: "Email",
            description: "Description",
            price_fcfa: "Sale price (FCFA)",
            price_eur: "Price (EUR)",
            cost_fcfa: "Purchase price (FCFA)",
            cost: "Total cost",
            profit: "Profit",
            deposit_fcfa: "Deposit paid (FCFA)",
            due_date: "Expected delivery date",
            create_order: "Create order",
            make_devis: "Generate quote",
            make_facture: "Generate invoice",
            documents: "Documents",
            no_documents: "No documents generated",
            print: "Print",
            doc_devis: "Quote",
            doc_facture: "Invoice",
            back_to_order: "Back to order",
            from: "From",
            bill_to: "Bill to",
            item: "Item",
            custom_order: "Custom order",
            devis_footer: "Quote valid for 30 days. Thank you for your trust.",
            facture_footer: "Thank you for your trust. GAB'S SERVICES SARL MALI.",
            track_title: "Tailoring order tracking",
            track_sub: "Enter your tracking code to see your order progress.",
            track_placeholder: "E.g. GSC-A1B2C3",
            track_button: "Track",
            add_category: "Add",
            category_name_fr: "Name (French)",
            category_name_en: "Name (English)",
            cat_price: "Sale price (FCFA)",
            cost_lines: "Cost breakdown",
            cost_lines_hint: "Add cost items (fabric, lining, labour...). The total is computed automatically.",
            cost_label_ph: "Label (e.g. Fabric)",
            add_cost_line: "Add a cost item",
            cat_price_hint: "The sale price and cost breakdown will pre-fill when creating an order with this category (editable afterwards).",
            parent_section: "Parent section (optional)",
            no_parent: "None — this is a main section",
            category_created: "Category created",
            no_categories: "No categories yet",
            add_field: "Add field",
            field_key: "Technical key",
            field_label_fr: "Label (French)",
            field_label_en: "Label (English)",
            field_unit: "Unit",
            field_created: "Field created",
            no_fields: "No measurement fields",
        },
    },
};
